module.exports = __webpack_public_path__ + "static/img/header-vip-pro-bg.31cc65a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/header-vip-pro-bg.png
// module id = qoOw
// module chunks = 215